var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"casos-de-exito"},[_vm._m(0),_c('vue-horizontal-list',{attrs:{"items":_vm.cards,"options":_vm.options},scopedSlots:_vm._u([{key:"default",fn:function({ item }){return [_c('card',{attrs:{"client":item}})]}}])})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"titles"},[_c('h4',[_vm._v(" Casos de Exito ")])])
}]

export { render, staticRenderFns }